module.exports = "/static/assets/e7f29f2cddb213cba47098c2e77debe3.gif";